import constant from "../../constant";

const resource = constant.api + "orders_items";

const state = {
  loadOrderItems: [],
  loadOrderItem: {},
};

const getters = {
  getAll: (state) => state.loadOrderItems,
  getCurrent: (state) => state.loadOrderItem,
};

const actions = {
  async getAll({ commit }) {
    const response = await this._vm.$api.fetch(resource);
    const data = Array.isArray(response) ? response : response?.data || [];
    commit("setAll", data);
    return data;
  },

  async show({ commit }, reference) {
    const response = await this._vm.$api.show(`${resource}/${reference}`);
    const data = response?.data || response;
    commit("setLoadOrderItem", data);
    return data;
  },

  async store({ dispatch }, payload) {
    const response = await this._vm.$api.create(resource, payload);
    await dispatch("getAll");
    return response;
  },

  async update({ dispatch }, { reference, data }) {
    const response = await this._vm.$api.update(
      `${resource}/${reference}`,
      data
    );
    await dispatch("getAll");
    return response;
  },

  async destroy({ commit, dispatch }, reference) {
    const response = await this._vm.$api.delete(`${resource}/${reference}`);
    const responseData = response?.data || response;
    if (responseData?.data && Array.isArray(responseData.data)) {
      commit("setAll", responseData.data);
    } else {
      await dispatch("getAll");
    }
    return response;
  },
};

const mutations = {
  setAll(state, data) {
    state.loadOrderItems = Array.isArray(data) ? data : [];
  },
  setLoadOrderItem(state, data) {
    state.loadOrderItem = data || {};
  },
  resetLoadOrderItem(state) {
    state.loadOrderItem = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
